import(/* webpackMode: "eager" */ "/tmp/build_fbe76f3a/apps/open/src/app/auth/reset-password/page.tsx");
